import React from "react";
import { DatePicker, Card, Typography, Spin, message, Button, Skeleton } from "antd";
import AvaragePriceTrendChart from "../components/AvaragePriceTrendChart";
import RecommendPriceTable from "../components/RecommendPriceTable";
import RankingDetailDrawer from "../components/RankingDetailDrawer";
import moment from "moment";
import "moment/locale/zh-tw";
import TW from "antd/es/date-picker/locale/zh_TW";
import { toJS } from "mobx";
import { setRecommendPriceTableData } from "../../controller/actions";
import { recommendPriceTableData } from "../../controller/stores";
import FilterContent from "../components/FilterContent";
import PriceDetailDrawer from "../components/PriceDetailDrawer";

import { apiPriceDetail, getApiAvaragePrice, getApiPricingPerformance, getApiPricingPaceBand, getApiRecommendData } from "../../controller/api";
import { PricingAPI } from "../../controller/PricingAPI";

class DashboardPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      priceType: [
        {
          pricetype_id: "normalday",
          pricetype_name: "平日",
        },
        {
          pricetype_id: "peakseasonday",
          pricetype_name: "旺日",
        },
        {
          pricetype_id: "holiday",
          pricetype_name: "假日",
        },
        {
          pricetype_id: "peakseasonholiday",
          pricetype_name: "旺假日",
        },
        {
          pricetype_id: "price",
          pricetype_name: "定價",
        },
      ],
      // 預設半年 (本月起算 6 個月)。上一期/下一期是依當前區間長度整段位移，
      // 所以這裡改動長度，翻頁的跨距會跟著變成半年。
      defaultMonth: [
        moment().startOf("month").format("YYYY-MM-DD"),
        moment().add(5, 'M').endOf("month").format("YYYY-MM-DD"),
      ],
      avaragePriceTrend: [],
      opsSeries: {},
      // date -> { category, name }，供走勢圖 tooltip 與「選擇特別假日」共用
      holidayMap: {},
      paceBand: {},
      dateSetting: {},
      detailDrawer: false,
      detailRows: [],
      detailLoading: false,
    };
    window.AvaragePriceTrend = this;
    this.chartRef = React.createRef();
  }

  componentDidMount() {
    this.getApiAvaragePrice();
    this.getApiPricingPaceBand();
  }

  componentWillUnmount() {
    this.onDateClear();
  }

  //設定 loading 狀態
  changeLoading = (type) => {
    this.setState({ loading: type });
  };

  //日期選擇
  onMonthChange = (e) => {
    this.setState(
      {
        defaultMonth: [
          moment(e).startOf("month").format("YYYY-MM-DD"),
          moment(e).endOf("month").format("YYYY-MM-DD"),
        ],
      },
      () => {
        this.getApiAvaragePrice();
      }
    );
  };
  onEndMonthChange = (e) => {
    this.setState(
      {
        defaultMonth: [
          this.state.defaultMonth[0],
          moment(e).endOf("month").format("YYYY-MM-DD"),
        ],
      },
      () => {
        this.getApiAvaragePrice();
      }
    );
  };

  onStartMonthChange = (e) => {
    this.setState(
      {
        defaultMonth: [
          moment(e).startOf("month").format("YYYY-MM-DD"),
          this.state.defaultMonth[1],
        ],
      },
      () => {
        this.getApiAvaragePrice();
      }
    );
  };
  onPrevPeriod = (e) => {
    let from = this.state.defaultMonth[0];
    let to = this.state.defaultMonth[1];
    let months = moment(to).diff(from, 'months') + 1;

    this.setState(
      {
        defaultMonth: [
          moment(from).add(-months, 'M').format("YYYY-MM-DD"),
          moment(to).add(-months, 'M').endOf("month").format("YYYY-MM-DD"),
        ],
      },
      () => {
        this.getApiAvaragePrice();
      }
    );
  };
  onNextPeriod = (e) => {
    let from = this.state.defaultMonth[0];
    let to = this.state.defaultMonth[1];
    let months = moment(to).diff(from, 'months') + 1;

    this.setState(
      {
        defaultMonth: [
          moment(from).add(months, 'M').format("YYYY-MM-DD"),
          moment(to).add(months, 'M').endOf("month").format("YYYY-MM-DD"),
        ],
      },
      () => {
        this.getApiAvaragePrice();
      }
    );
  };

  //清除所有條件
  onDateClear = () => {
    setRecommendPriceTableData([]);
    let series = [...this.state.avaragePriceTrend];
    series.map((item) => delete item.itemStyle);
    this.setState({ avaragePriceTrend: series, dateSetting: {} });
  };

  //移除搜尋條件
  onDateTagDelete = (date, type, e) => {
    e.preventDefault();
    this.unselectDate(date, type);
  };
  onShowDetailDrawer = (details) => {
    this.setState({
      detailDrawer: true,
      detailRows: details,
      detailLoading: false,
    })
  };
  onHideDetailDrawer = () => {
    this.setState({
      detailDrawer: false,
    })
  };

  // 用 api.js 既有的 apiPriceDetail (走共用 axios 設定)，不要自己拿
  // process.env.REACT_APP_API_DOMAIN 組網址 —— 那個變數只有 CI 會先
  // cp .env.production-prod.local .env.production.local 才會有值，
  // 本機直接 build 會變成 undefined/averageprice/detail 而 404。
  getApiPriceDetail = (date) => apiPriceDetail(date);

  /**
   * 逐日的住房率與 ADR，掛在價格走勢圖上對照用。
   *
   * 資料來自德安 PMS 的 Oracle (需要 VPN)，與價格走勢的本地資料獨立。
   * 失敗時只是這兩條線不畫，價格走勢照常 —— 不能讓 PMS 連不上就讓整個
   * 行情儀錶板不能用。
   */
  getApiPricingPerformance = () => {
    getApiPricingPerformance(this.state.defaultMonth[0], this.state.defaultMonth[1])
      .then((response) => {
        const items = (response.data && response.data.items) || [];
        const byDate = {};
        items.forEach((item) => {
          // PMS 回的是 YYYY/MM/DD，走勢圖的 x 軸是 YYYY-MM-DD
          byDate[String(item.dat).replace(/\//g, "-")] = item;
        });
        this.setState({ opsSeries: byDate });
      })
      .catch(() => {
        this.setState({ opsSeries: {} });
      });
  };

  /**
   * 在手住房率的正常帶 (未來 8 週)。未快取要 15 秒，所以獨立非阻塞地抓 ——
   * 不能讓它擋住價格走勢，回來再重繪那一層。窗口由後端決定，與圖表區間無關，
   * 所以只在掛載時抓一次，換月份不必重抓。
   */
  getApiPricingPaceBand = () => {
    getApiPricingPaceBand()
      .then((response) => {
        const items = (response.data && response.data.items) || [];
        const byDate = {};
        items.forEach((item) => {
          byDate[String(item.dat).replace(/\//g, "-")] = item;
        });
        this.setState({ paceBand: byDate });
      })
      .catch(() => {
        this.setState({ paceBand: {} });
      });
  };

  /**
   * 區間內的假日與補班日，供 tooltip 標示與「選擇特別假日」共用。
   *
   * 失敗時清空而不是保留舊值 —— 區間已經換了，留著上一段的假日會標到錯的日期。
   */
  getApiHolidays = () => {
    const [from, to] = this.state.defaultMonth;
    Promise.all([
      PricingAPI.holiday.index(from, to),
      PricingAPI.holiday.workdays(from, to),
    ])
      .then(([holidays, workdays]) => {
        const map = {};
        (holidays.data || []).forEach((row) => {
          map[row.date] = { category: row.category, name: row.name };
        });
        (workdays.data || []).forEach((row) => {
          map[row.date] = { category: 'workday', name: row.name };
        });
        this.setState({ holidayMap: map });
      })
      .catch(() => this.setState({ holidayMap: {} }));
  };

  //取得圖表數值
  getApiAvaragePrice = () => {
    let data = {
      series: [],
    };
    this.changeLoading(true);
    let from = moment(this.state.defaultMonth[0]);
    let to = moment(this.state.defaultMonth[1]);
    let dateArray = [];
    while (from <= to) {
      dateArray.push(moment(from).format("YYYY-MM-DD"));
      from = from.add(1, "days");
    }
    this.getApiPricingPerformance();
    this.getApiHolidays();
    getApiAvaragePrice(this.state.defaultMonth[0], this.state.defaultMonth[1])
      .then((response) => {
        this.changeLoading(false);
        dateArray.forEach((today) => {
          data.series.push({
            date: today,
            value: null,
          });
          if (response.data.length <= 0) {
            this.setState({ avaragePriceTrend: data.series });
          }
        });
        const last = response.data[response.data.length - 1];
        response.data.forEach((row) => {
          const index = data.series.findIndex(
            (mydate) => mydate.date === row.date
          );
          data.series[index].value = parseInt(row.averageprice);
          data.series[index].raw = row; // 將原始資料放進 series 方便之後使用
          if (row.date === last.date) {
            this.setState({ avaragePriceTrend: data.series });
          }
        });
      });
  };

  onDateDetailClick = async (e) => {
    let date = e.getAttribute("data-date");
    let series = [...this.state.avaragePriceTrend];
    console.log("select date:", date);
    let row = series.find((row) => row.date === date);
    if (row) {
      // 先開抽屜再等資料：averageprice/detail 要 10 秒左右，按下去若沒有任何反應
      // 會讓人以為沒點到而重複點
      this.setState({ detailDrawer: true, detailRows: [], detailLoading: true });
      // 抽屜蓋上來了，提示留在底下沒有意義，關掉才不會在抽屜收起後又冒出來
      this.hideChartTip();
      this.getApiPriceDetail(date)
        .then((response) => {
          if (response.status === 200) {
            this.onShowDetailDrawer(response.data);
          } else {
            throw new Error('Request failed: ' + response.statusText);
          }
        })
        .catch((error) => {
          this.setState({ detailDrawer: false, detailLoading: false });
          message.open({ type: "error", content: error.message });
        });
    } else {
      console.log("Select date not found: " + date);
    }

  };
  refreshPriceTable = (type) => {
    let dateSetting = { ...this.state.dateSetting };
    let dates = Object.keys(dateSetting);
    let types = this.state.priceType.map(type => type.pricetype_id);

    if (Array.isArray(type)) {
      types = type;
    } else if (type) {
      types = [type];
    }

    types.forEach(async (type) => {
      let newTypeDates = dates.filter((date) => dateSetting[date] === type);
      this.getApiRecommendData(type, newTypeDates);
    });
  }

  selectDate = (date, type) => {
    return new Promise((resolve, reject) => {
      this.setState((state, props) => {
        let series = [...state.avaragePriceTrend];
        let dateSetting = { ...state.dateSetting };

        dateSetting[date] = type;
        series.map((item) => {
          if (date === item.date) {
            return (item.itemStyle = { normal: { color: "#F2C94C" } });
          } else {
            return false;
          }
        });

        return {
          avaragePriceTrend: series,
          dateSetting
        };
      });
      resolve();
    });
  };

  unselectDate = (date, type) => {
    console.log("unselectDate", date, type)
    let dateSetting = { ...this.state.dateSetting };
    delete dateSetting[date];
    let series = [...this.state.avaragePriceTrend];
    series.map((item) => {
      if (date === item.date) {
        return delete item.itemStyle;
      } else {
        return false;
      }
    });
    let dates = Object.keys(dateSetting);
    if (dates.length <= 0) {
      this.setState({ avaragePriceTrend: series, dateSetting });
      setRecommendPriceTableData([]);
    } else {
      let data = dates.filter((date) => dateSetting[date] === type);
      this.setState({ avaragePriceTrend: series, dateSetting }, () => {
        this.getApiRecommendData(type, data);
      });
    }
  };

  //設定搜尋條件
  onDatePricetypeClick = async (e) => {
    let dateSetting = { ...this.state.dateSetting };
    let oldType;
    let exist = false;
    let date = e.getAttribute("data-date");
    let newType = e.getAttribute("data-type");

    if (dateSetting[date] !== undefined && dateSetting[date] !== newType) {
      exist = true;
      oldType = dateSetting[date];
    }
    // 更新日期類型按鈕顏色
    var list = e.parentElement.children;
    for (let item of list) {
      item.removeAttribute("data-active");
      if (item.className === "deleteButton") {
        item.disabled = false;
      }
    }
    e.setAttribute("data-active", "");

    if (newType === "delete") {
      if (exist) {
        this.unselectDate(date, oldType);
      }
    } else {
      // 選擇日期
      this.selectDate(date, newType).then(() => {
        this.refreshPriceTable(exist ? [newType, oldType] : [newType]);
      });
    }
    // 標記完就收起提示：它是點擊開的不會自己消失，留著會擋住剛標好的那根長條
    this.hideChartTip();
  };

  /** 收起價格走勢圖的提示 (提示是 triggerOn:"click" 開的，得主動關)。 */
  hideChartTip = () => {
    if (this.chartRef && this.chartRef.current) {
      this.chartRef.current.hideTip();
    }
  };

  /**
   * 查詢指定類型的建議價格並更新畫面
   * @param {*} type 類型 (normalday, peakseasonday, holiday, peaskseasonholiday, price)
   * @param {*} dates 
   */
  getApiRecommendData = async (type, dates) => {
    if (!dates || (Array.isArray(dates) && dates.length === 0)) return;
    this.changeLoading(true);
    return getApiRecommendData(dates)
      .then((response) => {
        let mobxRecommendListData = toJS(recommendPriceTableData.data);

        this.changeLoading(false);
        let data = response.data;
        if (mobxRecommendListData.length > 0) {
          const index = mobxRecommendListData.findIndex(
            (obj) => obj.type === type
          );
          if (index !== -1 && mobxRecommendListData[index].type === type) {
            mobxRecommendListData[index].dates = dates;
            mobxRecommendListData[index].data = data;
            if (mobxRecommendListData[index].dates.length <= 0) {
              mobxRecommendListData.splice(index, 1);
            }
          } else {
            mobxRecommendListData.push({ type, dates, data });
          }
        } else {
          mobxRecommendListData.push({ type, dates, data });
        }
        setRecommendPriceTableData(mobxRecommendListData);
      })
      .catch((error) => {
        this.changeLoading(false);
        message.open({ type: "error", content: error.message });
      });
  };

  generateDates = (from, to, weekdays) => {
    let fromDate = moment(from);
    let toDate = moment(to);
    let days = toDate.diff(fromDate, 'day');
    let results = [];

    for (let i = 0; i <= days; i++) {
      let momentDate = fromDate;
      let date = momentDate.format("YYYY-MM-DD");
      let weekday = momentDate.format('e');
      // 若為週六則為假日
      if (weekdays.includes(parseInt(weekday))) {
        results.push(date);
      }
      fromDate.add(1, 'day');
    }
    return results;
  };

  selectAllHolidays = async () => {
    // 週六為假日
    let dates = this.generateDates(this.state.defaultMonth[0], this.state.defaultMonth[1], [6]);
    let promises = [];
    for (let i = 0; i < dates.length; i++) {
      let p = this.selectDate(dates[i], 'holiday');
      promises.push(p);
    }
    Promise.all(promises).then(() => {
      this.refreshPriceTable();
    });
  };

  selectAllWorkdays = async () => {
    // 週日到五為平日
    let dates = this.generateDates(this.state.defaultMonth[0], this.state.defaultMonth[1], [0, 1, 2, 3, 4, 5]);
    let promises = [];
    for (let i = 0; i < dates.length; i++) {
      let p = this.selectDate(dates[i], 'normalday');
      promises.push(p);
    }
    Promise.all(promises).then(() => {
      this.refreshPriceTable();
    });
  };

  /**
   * 國定假日與連假標為旺假日。
   *
   * 這顆按鈕跟旁邊兩顆不同，是問 holidays 表而不是算星期幾 —— 春節、和平紀念日
   * 這類日子每年落在不同星期，用星期幾根本選不出來。旁邊兩顆維持原本的
   * 週六 / 週日到五邏輯，兩者刻意分開，不要合併。
   */
  selectAllSpecialHolidays = async () => {
    const dates = Object.keys(this.state.holidayMap)
      .filter((date) => this.state.holidayMap[date].category === 'special')
      .sort();

    if (dates.length === 0) {
      message.info('這段期間沒有特別假日');
      return;
    }

    await Promise.all(dates.map((date) => this.selectDate(date, 'peakseasonholiday')));
    this.refreshPriceTable();
    message.success(`已選取 ${dates.length} 天特別假日`);
  };

  render() {
    return (
      <>
        <Spin spinning={this.state.loading}>
          <PriceDetailDrawer visible={this.state.detailDrawer} details={this.state.detailRows} loading={this.state.detailLoading} onClose={this.onHideDetailDrawer} />
          <Card>
            <Typography.Title level={3}>平均價格走勢</Typography.Title>
            <Button onClick={this.onPrevPeriod}>上一期</Button>
            <DatePicker
              allowClear={false}
              format="YYYY-MM"
              inputReadOnly={true}
              locale={TW}
              picker="month"
              placeholder="請選擇月份"
              onChange={this.onStartMonthChange}
              value={moment(this.state.defaultMonth[0])}
              defaultValue={moment(this.state.defaultMonth[0])}
              style={{ marginLeft: 5 }}
            />
            <DatePicker
              allowClear={false}
              format="YYYY-MM"
              inputReadOnly={true}
              locale={TW}
              picker="month"
              placeholder="請選擇月份"
              onChange={this.onEndMonthChange}
              value={moment(this.state.defaultMonth[1])}
              defaultValue={moment(this.state.defaultMonth[1])}
              style={{ marginLeft: 5 }}
            />
            <Button onClick={this.onNextPeriod} style={{ marginLeft: 5 }}>下一期</Button>
            <Button onClick={this.selectAllWorkdays} style={{ marginLeft: 5 }}>選擇平日</Button>
            <Button onClick={this.selectAllHolidays} style={{ marginLeft: 5 }}>選擇假日</Button>
            <Button onClick={this.selectAllSpecialHolidays} style={{ marginLeft: 5 }}>選擇特別假日</Button>
            <br />
            {this.state.avaragePriceTrend === null ? <Skeleton style={{ height: 300 }} /> : (
              <AvaragePriceTrendChart
                ref={this.chartRef}
                changeLoading={this.changeLoading}
                priceType={this.state.priceType}
                dateSetting={this.state.dateSetting}
                avaragePriceTrend={this.state.avaragePriceTrend}
                holidayMap={this.state.holidayMap}
                opsSeries={this.state.opsSeries}
                paceBand={this.state.paceBand}
                onDatePricetypeClick={this.onDatePricetypeClick}
              />
            )}

            {Object.keys(this.state.dateSetting).length > 0 ? (
              <FilterContent
                priceType={this.state.priceType}
                dateSetting={this.state.dateSetting}
                onDateTagDelete={this.onDateTagDelete}
                onDateClear={this.onDateClear}
              />
            ) : null}
            <Typography.Title level={3} style={{ marginTop: 30 }}>
              建議價格
            </Typography.Title>
            <RecommendPriceTable priceType={this.state.priceType} />
            <RankingDetailDrawer />
          </Card>
        </Spin>
      </>
    );
  }
}
export default DashboardPage;
